export const merchantInputLabelSx = {
  color: '#06B6D4',
  fontWeight: 700,
  fontSize: '1rem',
  lineHeight: 1.35
}

export const merchantInputSx = {
  color: '#E6E9EF',
  '&::before': {
    borderBottom: '1px solid rgba(230,233,239,0.3)'
  },
  '&:hover:not(.Mui-disabled)::before': {
    borderBottom: '1px solid rgba(230,233,239,0.5)'
  },
  '&::after': {
    borderBottom: '2px solid #7C3AED'
  }
}

export const merchantTextFieldProps = {
  variant: 'standard',
  InputLabelProps: {
    shrink: true,
    sx: merchantInputLabelSx
  },
  InputProps: {
    sx: merchantInputSx
  }
}

/** Cyan pill — matches venue event tile “View/Edit” and related primary row actions */
export const merchantCyanGradientButtonSx = {
  textTransform: 'none',
  fontWeight: 700,
  borderRadius: 999,
  px: 1.6,
  py: 0.75,
  minWidth: '4.75rem',
  color: '#082B18',
  background: 'linear-gradient(135deg, #67E8F9 0%, #22D3EE 100%)',
  boxShadow: '0 2px 10px rgba(34, 211, 238, 0.25)',
  '&:hover': {
    background: 'linear-gradient(135deg, #7DD3FC 0%, #38BDF8 100%)',
    boxShadow: '0 4px 14px rgba(34, 211, 238, 0.35)'
  }
}

export const merchantPrimaryButtonSx = {
  textTransform: 'none',
  fontWeight: 800,
  borderRadius: 999,
  px: 2.5,
  py: 1.1,
  background: 'linear-gradient(90deg,#7C3AED,#06B6D4)',
  boxShadow: '0 0 28px rgba(124,58,237,0.4)',
  '&:hover': {
    background: 'linear-gradient(90deg,#6D28D9,#0891B2)',
    boxShadow: '0 0 36px rgba(124,58,237,0.5)'
  },
  '&:disabled': {
    background: 'rgba(255,255,255,0.1)',
    color: 'rgba(230,233,239,0.5)'
  }
}

export const merchantSecondaryButtonSx = {
  textTransform: 'none',
  borderColor: 'rgba(167,139,250,0.65)',
  color: '#C4B5FD',
  '&:hover': {
    borderColor: 'rgba(167,139,250,0.9)',
    bgcolor: 'rgba(167,139,250,0.1)'
  }
}

/** Legacy bottom-of-form back. Page wayfinding uses PageBackRow. */
export const merchantBackButtonSx = {
  mt: 1,
  mb: 0.5,
  color: 'rgba(230,233,239,0.9)',
  textTransform: 'none',
  fontSize: '1.1rem',
  fontWeight: 500,
  py: 1,
  '&:hover': {
    bgcolor: 'rgba(255,255,255,0.05)'
  }
}

export const merchantCompactPageHeaderRowSx = {
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  gap: 1,
  mt: 0.1,
  mb: 0.1
}

export const merchantCompactPageTitleSx = {
  color: 'rgba(103, 232, 249, 0.88)',
  fontSize: '1rem',
  fontWeight: 800,
  letterSpacing: '0.08em',
  lineHeight: 1.1,
  textTransform: 'uppercase',
  minWidth: 0
}

/**
 * Section headers on venue show / forms (Venue Events, Event Hosts, DATE, etc.).
 * Between compact page title (~1rem) and previous small caps; tight line-height keeps header rows compact.
 */
export const merchantVenueSubsectionTitleSx = {
  color: 'rgba(103, 232, 249, 0.88)',
  fontWeight: 800,
  fontSize: '0.9rem',
  letterSpacing: '0.07em',
  lineHeight: 1.05,
  textTransform: 'uppercase'
}

export const merchantTopNavLinkSx = {
  display: 'inline-flex',
  alignItems: 'center',
  color: '#67E8F9',
  textDecoration: 'none',
  textTransform: 'none',
  fontSize: '1rem',
  fontWeight: 800,
  lineHeight: 1.1,
  whiteSpace: 'nowrap',
  '&:hover': {
    textDecoration: 'underline',
    color: '#A5F3FC'
  }
}

export const merchantLinkSx = {
  textDecoration: 'none'
}
